import { Button, Flex } from '@lokalise/louis';

import { useStyleGuideContext } from '../../StyleGuideContext';
import { Container, SearchInputContainer, Title } from './styles';

export const StyleGuideListToolbar = ({ onSearch }: { onSearch: (value: string) => void }) => {
    const { uploadStyleGuideFiles } = useStyleGuideContext();

    return (
        <Container gap={4} align="center" justify="space-between">
            <Title>Style guides</Title>
            <Flex gap={2} wrap="nowrap">
                <Button size="sm" variant="primary" onClick={() => uploadStyleGuideFiles()}>
                    Upload style guide
                </Button>
                <SearchInputContainer
                    autoFocus
                    inputSize="small"
                    placeholder="Search guides"
                    clearable
                    onValueChange={onSearch}
                />
            </Flex>
        </Container>
    );
};

export default StyleGuideListToolbar;
